import Footer from "../components/Footer";

function Services() {
  return (
    <div>
      <h1>Services</h1>
      <Footer />
    </div>
  );
}

export default Services;
